import { validationAddress, isExistZipcode } from '@/services/location';
import { useRef } from 'react';
import { useRequest } from 'umi';

export default function useLocationModel() {
  const exactAddress = useRef<API.Address | null>({} as API.Address);
  const isExitZipCode = useRef(true);
  const { loading, run } = useRequest(validationAddress, {
    cacheKey: 'term',
    manual: true,
    formatResult: (res) => res,
    onSuccess: (data) => {
      exactAddress.current = data;
    },
  });
  const { run: fetchIsExistZipCode } = useRequest(isExistZipcode, {
    cacheKey: 'term',
    manual: true,
    formatResult: (res) => res,
    onSuccess: (data) => {
      isExitZipCode.current = data;
    },
  })
  return { exactAddress, fetch: run, loading, fetchIsExistZipCode, isExitZipCode };
}
